import InfoPage, { InfoSection } from "@/components/InfoPage";
import { COMPANY } from "@/data/site";

const Privacy = () => (
  <InfoPage
    eyebrow="Privacy Policy"
    title="Privacy Policy."
    intro={`This policy explains what personal data ${COMPANY.legalName} collects, why, and the choices you have. We process your data in line with the Digital Personal Data Protection Act, 2023.`}
    updated="October 2026"
    testId="privacy-page"
  >
    <InfoSection heading="What we collect">
      <p><span className="text-[#111111]">Account details</span> — your name, email address, phone number and password (stored encrypted).</p>
      <p><span className="text-[#111111]">Order details</span> — shipping addresses, items purchased, order history and loyalty points.</p>
      <p><span className="text-[#111111]">Payment details</span> — handled entirely by Razorpay. We receive only a payment reference, never your card or UPI credentials.</p>
      <p><span className="text-[#111111]">Calculator inputs</span> — the height, weight and goals you enter in the Protein Index calculator stay in your browser and are not sent to us.</p>
    </InfoSection>

    <InfoSection heading="How we use it">
      <p>To process and deliver your orders, send order and shipping updates, manage your account and loyalty points, answer your questions, and — only if you subscribe — send our newsletter.</p>
    </InfoSection>

    <InfoSection heading="Who we share it with">
      <p>Only the partners needed to fulfil your order: Razorpay (payments), Shiprocket and its courier partners (delivery), and our email provider (order notifications). We do not sell your personal data.</p>
    </InfoSection>

    <InfoSection heading="Cookies">
      <p>We use a secure login cookie to keep you signed in, and your browser's local storage to remember your cart. We do not use advertising cookies.</p>
    </InfoSection>

    <InfoSection heading="How long we keep it">
      <p>Account data is kept while your account is active. Order records are kept for as long as tax and accounting law requires.</p>
    </InfoSection>

    <InfoSection heading="Your rights">
      <p>You can ask us to access, correct or erase your personal data, or withdraw consent for marketing, by writing to {COMPANY.email}. You can unsubscribe from the newsletter at any time.</p>
    </InfoSection>

    <InfoSection heading="Grievance officer">
      <p>For any privacy concern, contact our grievance officer at {COMPANY.email}. We will respond within 30 days.</p>
    </InfoSection>
  </InfoPage>
);

export default Privacy;
